import { render, staticRenderFns } from "./NavigationConfig.vue?vue&type=template&id=586a76a9&scoped=true"
import script from "./NavigationConfig.vue?vue&type=script&lang=js"
export * from "./NavigationConfig.vue?vue&type=script&lang=js"
import style0 from "./NavigationConfig.vue?vue&type=style&index=0&id=586a76a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a76a9",
  null
  
)

export default component.exports